import React, { useState } from "react";
import styled from "styled-components";
import "swiper/components/pagination/pagination.min.css";
// Import Swiper styles
// import "./styles.css";
// import Swiper core and required modules
import SwiperCore, { Pagination } from "swiper/core";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/swiper.min.css";
import data from "../data/rushdata.json";

SwiperCore.use([Pagination]);

const RushBuisness = () => {
  const [hover, sethover] = useState(2);
  return (
    <Wrapper>
      <div className="section-center text-center why_rush">
        <div className="rush__top">
          <h1>Why Rush</h1>
          <p>
            Rush helps Businesses move items from where they currently to where
            you need them to be, all in real-time.
          </p>
        </div>
        <div className="rush__bottom">
          <div className="why_rush_for_mobile">
            <Swiper
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              pagination={{
                clickable: true,
              }}
              className="mySwiper"
            >
              {data.buisnessData.map(({ id, icon, rushH1, rushP }) => (
                <SwiperSlide>
                  <div className="single__rush" key={id}>
                    <div className="rush__icon">
                      <img src={icon} alt="" />
                    </div>
                    <div className="rush__des">
                      <h1 className="rushH1">{rushH1}</h1>
                      <p className="rushp">{rushP}</p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <div className="why_rush_for_desktop">
            {data.rushData.map(({ id, icon, rushH1, rushP }) => (
              <div
                key={id}
                className={
                  hover === id ? "single__rush active" : "single__rush"
                }
                onMouseOver={() => sethover(id)}
              >
                <div className="rush__icon">
                  <img src={icon} alt="" />
                </div>
                <div className="rush__des">
                  <h1 className="rushH1">{rushH1}</h1>
                  <p className="rushp">{rushP}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {data.buisImg.map(({ id, buisImage }) => (
          <div className="buisness__images" key={id}>
            <img src={buisImage} alt="buisImage" />
          </div>
        ))}

        <div className="order__rush">
          <div className="order__rush_left">
            <h1>Grow your business to new bounds</h1>
            <p>
              Running a business is tough enough, don’t worry about moving
              goods, raw materials and industrial items to the places you need
              them to be, Choose Wecanrush as your delivery partner and focus on
              growing your business.
            </p>
          </div>

          <div className="order">
            {data.buisorderImg.map(({ id, orderImage }) => (
              <div className="order__rush_right" key={id}>
                <img src={orderImage} alt="orderImage" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  /* padding: 20px !important; */
  @media screen and (max-width: 768px) {
    .why_rush {
      padding: 0px 12px !important;
    }
    .rush__top {
      padding-top: 76px;
      overflow: hidden !important;
      h1 {
        font-size: 36px !important;
      }
      p {
        font-size: 14px !important ;
        line-height: 19px !important;
        text-align: center !important;
        width: 405px !important;
      }
    }
    .single__rush {
      width: 440px !important;
      margin: 0 20px;
      box-shadow: 0px 0px 50px 0px #e7f5ff !important;
    }
    .buisness__images {
      height: 316.07px !important;

      img {
        width: 500px !important;
      }
    }

    .order__rush {
      display: flex !important;
      flex-direction: column !important;
      margin: 0 !important;
    }
    .order__rush_left {
      /* margin-right: 150px; */
      margin-top: 110px;
      text-align: center;
      align-content: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 478px;
      margin: auto;
      h1 {
        font-family: Gilroy-Heavy;
        font-size: 40px;
        line-height: 46px;
        align-items: center;
        color: #6300ff;
        text-align: center !important;
        margin-left: 36px !important;
      }
      p {
        font-family: "Manrope";
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 28px;
        color: #545777;
        text-align: center !important;
        margin-top: 25px;
        -webkit-letter-spacing: 0.8px;
        -moz-letter-spacing: 0.8px;
        -ms-letter-spacing: 0.8px;
        letter-spacing: 0.8px;
        width: 488px !important;
      }
    }
    .order {
      position: relative;

      .order__rush_right {
        img {
          width: 100% !important;
          display: block;
        }
      }
      .order__rush_right_mobile {
        display: block !important;
        width: 380px !important;
        height: 417.71px !important;
        margin-left: -10px;
        img {
          width: 100% !important;
        }
      }
    }

    .why_rush_for_desktop {
      display: none !important;
    }
    .why_rush_for_mobile {
      display: block !important;
      width: 100%;
    }
    .mySwiper {
      width: 516px;
      padding: 78px 0;
    }
    .rush__des p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 600;
      font-size: 15px;
      line-height: 22px;
      color: #464861;
      -webkit-letter-spacing: 1px;
      -moz-letter-spacing: 1px;
      -ms-letter-spacing: 1px;
      letter-spacing: 1px;
      margin-top: 10px;
      width: 300px;
    }
  }
  @media screen and (max-width: 440px) {
    .rush__top {
      p {
        font-family: Manrope;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 19px;
        text-align: center;
        width: 100% !important;
        color: #6d7d93;
      }
    }
    .rush__des p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500 !important;
      font-size: 14px !important;
      line-height: 19px !important;
      color: #464861;
      -webkit-letter-spacing: 1px;
      -moz-letter-spacing: 1px;
      -ms-letter-spacing: 1px;
      letter-spacing: 1px;
      margin-top: 10px !important;
      width: 100% !important;
    }
    .swiper-slide {
      flex-shrink: 0;
      width: 100% !important;
      height: 100%;
      position: relative;
      transition-property: transform;
      padding: 20px !important;
    }

    .rush__icon {
      padding-top: 35px;
    }

    .order {
      margin-top: 100px;
      margin-left: -10px;
      margin-bottom: -200px;
    }

    .order__rush_left {
      text-align: center;
      justify-content: center;
      width: 100% !important;
      h1 {
        font-family: Gilroy-Heavy;
        font-size: 40px;
        line-height: 46px;
        -webkit-align-items: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        color: #6300ff;
        text-align: left !important;
        margin-left: 0px !important;
        width: 358px !important;
        font-family: Gilroy-Heavy !important;
        font-size: 30px !important;
        line-height: 46px !important;
      }
      p {
        font-family: "Manrope";
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 28px;
        color: #545777;
        text-align: left;
        width: 100% !important;
        margin-top: 25px;

        letter-spacing: 0.8px;
        text-align: left !important;
      }
    }
    .buisness__images {
      height: 176.07px !important;
      width: 410px;
      margin-top: -70px !important;
      text-align: left !important;
      img {
        width: 100% !important;
      }
    }
    .mySwiper {
      width: 100% !important;
      padding: 27px 0 !important;
    }
    .single__rush {
      width: 100% !important;
      border-radius: 15px !important;
      box-shadow: 0px 0px 50px 0px #e7f5ff !important;
      box-sizing: border-box !important;
      text-align: left;
      margin: 0px !important;
      width: 361px !important;
      height: 329px !important;
      margin-left: -15px !important;
    }
    .swiper-container-horizontal > .swiper-pagination-bullets,
    .swiper-pagination-custom,
    .swiper-pagination-fraction {
      max-width: 100% !important;
      display: flex;
      justify-content: center;
    }
    .rush__bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: left;
      margin-top: 110px;
      margin-bottom: 138px;
    }
  }

  @media screen and (max-width: 375px) {
    .individuals {
      padding: 0px 12px !important;
    }
  }

  .why_rush_for_mobile {
    display: none;
  }
  .why_rush_for_desktop {
    display: flex;
    flex-direction: row;
    align-items: space-between;
    width: 100%;
    margin: auto;
  }

  .rush__bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: left;
    margin-top: 110px;
    margin-bottom: 180px;
  }

  .rush__icon {
    padding-left: 5px;
  }

  .rush__top {
    h1 {
      font-family: Gilroy-Heavy;
      font-size: 48px;
      line-height: 56px;
      text-align: center;
      color: #6300ff;
      width: 243px;
      height: 61px;
      margin: auto;
    }

    p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      line-height: 27px;
      text-align: center;
      color: #6d7d93;
      width: 950px;
      margin: auto;
      height: 54px;
      letter-spacing: 1px;
      margin-top: 40px;
    }
  }

  .rush__des {
    margin-top: 40px;
    h1 {
      font-family: Gilroy;
      font-style: normal;
      font-weight: 800;
      font-size: 24px;
      line-height: 29px;
      color: #2a60e4;
    }
    p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 22px;
      color: #464861;
      letter-spacing: 1px;
      margin-top: 10px;
    }
  }
  .buisness__images {
    height: 579px;
    margin: 0;
    img {
      width: 1180px;
    }
  }
  .order__rush {
    display: flex;
    justify-content: center;
    margin-top: 150px;
  }

  .order__rush_right {
    width: 750px;
    height: 607px;
  }

  div#order_id1 {
    position: absolute;
    top: -10%;
    left: 6%;
  }

  .order {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .order__rush_left {
    /* margin-right: 150px; */
    margin-top: 110px;
    h1 {
      font-family: Gilroy-Heavy;
      font-size: 40px;
      line-height: 46px;
      display: flex;
      align-items: center;
      color: #6300ff;
      width: 420px;
      height: 92px;
      text-align: left;
    }

    p {
      font-family: "Manrope";
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 28px;
      color: #545777;
      text-align: left;
      width: 460px;
      height: 100px;
      margin-top: 25px;
      letter-spacing: 0.8px;
    }
  }

  .single__rush {
    width: 340px;
    border-radius: 15px !important;
    /* box-shadow: 0px 0px 50px 0px #e7f5ff !important; */
    box-sizing: border-box !important;
    padding: 15px !important;
    margin-right: 50px;
    text-align: left;
    padding-top: 50px !important;
    padding-bottom: 50px !important;
    cursor: pointer;
    transition: 0.3s;
  }
  .single__rush.active {
    width: 340px;
    border-radius: 15px !important;
    box-shadow: 0px 0px 50px 0px #e7f5ff !important;
    box-sizing: border-box !important;
    padding: 15px !important;
    margin-right: 50px;
    text-align: left;
    padding-top: 50px !important;
    padding-bottom: 50px !important;
    cursor: pointer;
    transition: 0.3s;
  }
  .single__rush:hover {
    transform: scale(1.1);
  }
  .swiper-container.swiper-container-initialized.swiper-container-horizontal.swiper-container-pointer-events.mySwiper {
    padding-bottom: 90px;
  }
  .swiper-container-horizontal > .swiper-pagination-bullets,
  .swiper-pagination-custom,
  .swiper-pagination-fraction {
    width: 500px !important;
  }
  .swiper-container-horizontal
    > .swiper-pagination-bullets
    .swiper-pagination-bullet {
    margin: 0 4px;
    width: 10px;
    height: 5px;
    border-radius: 5px;
  }
  .order__rush_right_mobile {
    position: absolute;
    top: -200px;
    left: -40px;
  }
`;

export default RushBuisness;
